import TagManager from 'react-gtm-module';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PayPalButtons } from "@paypal/react-paypal-js";
import { markPaymentDeparture } from '../../../../../helpers/shop/couponSession';

import { emptyCart } from '../../../../../actions/shop';
import { htmlMsg } from '../../../../../actions/swal_msg';
import { shippingMethodSelected } from '../../../../../actions/shop_shipping';
import { attachPaypalError } from '../../../../../actions/payment/paypal_payment';

import { CUSTOMER_EMAIL } from '../../../../../constants/constants';
import { SHIPPING_METHOD } from '../../../../../constants/shop/shop_constants';

const tagManagerArgs = {
    gtmId: 'GTM-KQMW2JG'
};
TagManager.initialize(tagManagerArgs);

const MyPaypalButtons = ({ orderData }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { paypal_id, order_id, nefro_reference } = orderData;
	// generar pedido de PayPal
	const createOrder = () => {
		markPaymentDeparture({ orderId: order_id, context: 'fast-checkout' });
		return Promise.resolve(paypal_id);
	};

	// const createOrder = (data, actions) => {
	// 	const address_line_2 = int_num ? `Int. ${int_num}, Col. ${colony}` : `Col. ${colony}`;
	// 	let order_subtotal = 0;
	// 	const items = item.map(({
	// 		title, variant_title, url, barcode, description,
	// 		discount: { total: total_discount, item_total }
	// 	}) => {
	// 		const value = (total_discount + item_total);
	// 		// no se incluye imagen de producto
	// 		// PayPal no soporta enlace de Google Drive
	// 		order_subtotal += value;
	// 		return {
	// 			name: getTitle(title, variant_title), quantity: 1,
	// 			category: 'DIGITAL_GOODS', sku: barcode,
	// 			url: `${process.env.REACT_APP_WEBSITE_URL}/tienda/producto/${url}/${barcode}`,
	// 			description: description.length > 250 ? description.slice(0, 250) : description,
	// 			unit_amount: { currency_code: "MXN", value: value.toString() }
	// 		};
	// 	});
	// 	return actions.order.create({
	// 		purchase_units: [
	// 		  	{
	// 			  	description: "Compra en Tienda Nefrópolis.",
	// 			  	amount: {
	// 			  		currency_code: "MXN",
	// 			  		value: total.toString(),
	// 					breakdown: {
	// 						item_total: {
	// 							currency_code: "MXN",
	// 							value: (Math.round(order_subtotal * 1e2) / 1e2).toString()
	// 						},
	// 						shipping: {
	// 							currency_code: "MXN",
	// 							value: cost.toString()
	// 						},
	// 						discount: {
	// 							currency_code: "MXN",
	// 							value: (discount + promos_discount).toString()
	// 						}
	// 					}
	// 				},
	// 				// description: "Compra de productos",
    //     			// invoice_id: "1", // opcional: identificador único
	// 				// items: [
	// 				// 	{
	// 				// 		name: 'Producto(s) Nefrópolis',
	// 				// 		quantity: '1',
	// 				// 		category: 'DIGITAL_GOODS',
	// 				// 		description: '',
	// 				// 	},
	// 				// ]
	// 				items,
	// 				shipping: {
	// 					name: {
	// 						full_name: getTitle(name, lastname)
	// 					},
	// 					address: {
	// 						address_line_1: `${street} ${ext_num}`,
	// 						address_line_2,
	// 						admin_area_2: city,
	// 						admin_area_1: state,
	// 						postal_code: postalcode,
	// 						country_code: "MX"
	// 					}
	// 				}
	// 		  	}
	// 		],
	// 		application_context: {
	// 			return_url: `${process.env.REACT_APP_WEBSITE_URL}/gracias-por-tu-compra/${nefro_reference}`,
	// 			user_action: "PAY_NOW"
	// 		}
	// 	})
	// 	.then(async (orderID) => {
	// 		await updatePaypalOrder({
	// 			order_id, paypal_order_id: orderID
	// 		});
	// 		return orderID;
	// 	});
	// };

	const onApprove = (data, actions) => {
		// const { orderID } = data;
		// Tag Manager
		window.dataLayer.push({
			event: 'nefro-order'
		});
		return actions.order.capture().then(async function (details) {
			// const { id, status, create_time, update_time } = details;
			// const resp = await confirmPaypalOrder({
			// 	id, status, create_time, update_time, order_id
			// });
			// if (resp.status) {}
			dispatch(emptyCart());
			dispatch(shippingMethodSelected({
				selected: SHIPPING_METHOD,
				radio_button: null
			}));
			navigate(`/gracias-por-tu-compra/${nefro_reference}`);
		});
	};

	const onError = async (data, actions) => {
		try {
			if (order_id) {
				// data.message es un string que tiene texto + JSON al final
				const message = data.message;

				// extraer el JSON después del primer salto de línea o después del punto
				// estructura => "Error: ...\n<JSON>"
				// buscar el primer '{' y tomar desde ahí
				const json_start = message.indexOf('{');
				if (json_start === -1) {
					await attachPaypalError({
						order_id, message: data.message
					});
					return;
				}

				const json_string = message.slice(json_start);
				const ErrObj = JSON.parse(json_string);

				if (
					ErrObj.details &&
					Array.isArray(ErrObj.details) &&
					ErrObj.details.length > 0
				) {
					const { message, details } = ErrObj;
					const { field, value, issue, description } = details[0];
					await attachPaypalError({
						order_id, field, value, issue, description, message
					});
				}
			}
			htmlMsg(
				'warning', 'Checkout',
				`<h6>Parece que su pedido no ha sido generado. Si se trata de un error, comuníquese con nosotros al correo: ${CUSTOMER_EMAIL}</h6>`,
				'Entendido'
			);
		} catch (err) {
			htmlMsg(
				'warning', 'Checkout',
				`<h6>Parece que su pedido no ha sido generado. Si se trata de un error, comuníquese con nosotros al correo: ${CUSTOMER_EMAIL}</h6>`,
				'Entendido'
			);
		};
	};
	
    return (
		<PayPalButtons
			style={{ layout: "vertical" }}
           	createOrder={ createOrder }
			onApprove={ onApprove }
			onError={ onError }
        />
    );
};

export default MyPaypalButtons;
